// 过滤行内 style
export const regStyle = /style\s*?=\s*?(['"])[\s\S]*?\1/gi

export const colour = [
  '#3881F7',
  '#FF4C4C',
  '#46DFF4',
  '#F8EF9F',
  '#9E72FA',
  '#D6804F',
  '#32C77F',
  '#27628D',
  '#A4B5C1',
  '#63A2D0',
  '#A7AABD',
  '#E6F4F1',
  '#4AABA6',
  '#F9F871',
  '#00CAEE',
  '#6772E8',
  '#C3A875',
  '#AF003A',
  '#6FFACB'
]

// A股股本变动原因
export const shareChangeReasonOfHs = {
  1004: 'A 股发行前股本',
  1021: '非公开增发 A 股',
  1031: '送转股',
  1033: '激励期权行权',
  1201: '可转换债券转股',
  1501: '股份回购后注销',
  2001: 'A 股上市',
  2004: 'A 股发行法人配售上市',
  2006: '三板上市',
  2011: '配股上市',
  2021: '增发 A 股上市',
  2023: '增发 A 股法人配售上市',
  2041: '股权分置方案实施',
  2042: '股权分置股份追送',
  2043: '股权分置限售流通',
  2055: '股权转让',
  2056: '其他',
  2058: '股权激励限售流通',
  2060: '发行前股份限售流通',
  2063: '无限售不减持承诺到期',
  2064: '股份性质变动-无限售承诺不减持',
  3010: '挂牌交易',
  3020: '增发变动',
  3030: '增发股份限售流通',
  3040: '发行人持股限售流通',
  3050: '股东增持变动'
}
